import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import MasterDataUserMenu from '../../../components/MasterData/MasterDataUserMenu';
import MasterDataUserFirstPage from '../../../components/MasterData/MasterDataUserFirstPage';
import MasterDataUserSecondPage from '../../../components/MasterData/MasterDataUserSecondPage';
import MasterDataUserThirdPage from '../../../components/MasterData/MasterDataUserThirdPage';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_USER_UPDATE } from '../../../constants/menuPermissionConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import API_SEARCH from '../../../api/apiSearch';
import API_AUTHENTICATION from '../../../api/apiAuthentication';

class UserEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            clientId: '',
            id: 0,
            userCategory: {
                data: [
                    {
                        value: 'nexsoft',
                        label: 'Nexsoft'
                    },
                    {
                        value: 'distributor',
                        label: 'Distributor'
                    },
                    {
                        value: 'principal',
                        label: 'Principal'
                    }
                ],
                value: ''
            },
            isCustomerService: false,
            assignable: false,
            email: '',
            language: {
                placeholder: 'Indonesia',
                value: 'id-ID'
            },
            level: {
                data: [
                    {
                        value: 'cslv1',
                        label: 'Level 1'
                    },
                    {
                        value: 'cslv2',
                        label: 'Level 2'
                    }
                ],
                value: ''
            },
            specialization: {
                page: 1,
                limit: 100,
                data: [],
                value: []
            },
            lead: {
                data: [],
                value: ''
            },
            isLead: false,
            distributor: {
                page: 1,
                limit: 10,
                data: [],
                value: []
            },
            idCard: '',
            title: {
                data: [
                    {
                        value: 'Tn',
                        label: 'Tn'
                    },
                    {
                        value: 'Ny',
                        label: 'Ny'
                    },
                    {
                        value: 'Nn',
                        label: 'Nn'
                    }
                ],
                value: ''
            },
            firstName: '',
            lastName: '',
            gender: {
                data: [
                    {
                        value: 'L',
                        label: 'Laki-Laki'
                    },
                    {
                        value: 'P',
                        label: 'Perempuan'
                    }
                ],
                value: ''
            },
            countryCode: '+62',
            phoneNumber: '',
            createdAt: '',
            updatedAt: '',
            updatedBy: '',
            status: false,
            username: '',
            password: '',
            confirmPassword: '',
            role: {
                page: 1,
                limit: 10,
                data: [],
                value: ''
            },
            dataGroup: {
                page: 1,
                limit: 10,
                data: [],
                value: ''
            },
            emailVerified: false,
            phoneVerified: false,
            isValidated: false,
            isAlreadyHaveAccount: '',
            detailUser: '',
            showSelectUserCategoryModal: false,
            showSuccessAlert: false,
            showWarningAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListCustomerService = () => {
        API_MASTER_DATA.getAllCustomer(1, 100, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let customerService = getContent(res).map(cs => ({
                        value: cs.user_nexcare_id,
                        label: cs.name
                    }))
                    this.setState({
                        lead: {
                            ...this.state.lead,
                            data: customerService
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListSpecialization = () => {
        API_MASTER_DATA.getListComplaint(this.state.specialization.page, this.state.specialization.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let complaintData = getContent(res).map(complaint => ({
                        value: complaint.id,
                        label: complaint.complaint_description
                    }))
                    this.setState({
                        specialization: {
                            ...this.state.specialization,
                            data: complaintData
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListDistributor = () => {
        API_MASTER_DATA.getListCustomer(this.state.distributor.page, this.state.distributor.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let distributor = getContent(res).map(distributor => ({
                        value: distributor.id,
                        label: distributor.customer_name
                    }))
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributor
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchDistributor = keyword => {
        API_MASTER_DATA.getSearchCustomer(this.state.distributor.page, this.state.distributor.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let distributor = getContent(res).map(distributor => ({
                        value: distributor.id,
                        label: distributor.customer_name
                    }))
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributor
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListRole = userCategory => {
        API_MASTER_DATA.getListFilterRoleUser(this.state.role.page, this.state.role.limit, userCategory, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let role = getContent(res).map(role => ({
                        value: role.id,
                        label: role.role_id
                    }))
                    this.setState({
                        role: {
                            ...this.state.role,
                            data: role
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchRole = keyword => {
        API_SEARCH.getListFilterRoleUser(this.state.role.page, this.state.role.limit, keyword, this.state.userCategory.value.value, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let role = getContent(res).map(role => ({
                        value: role.id,
                        label: role.role_id
                    }))
                    this.setState({
                        role: {
                            ...this.state.role,
                            data: role
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListDataGroup = () => {
        API_MASTER_DATA.getListDataGroupUser(this.state.dataGroup.page, this.state.dataGroup.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let dataGroup = getContent(res).map(dataGroup => ({
                        value: dataGroup.id,
                        label: dataGroup.group_id
                    }))
                    this.setState({
                        dataGroup: {
                            ...this.state.dataGroup,
                            data: dataGroup
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchDataGroup = keyword => {
        API_SEARCH.getListDataGroupUser(this.state.dataGroup.page, this.state.dataGroup.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let dataGroup = getContent(res).map(dataGroup => ({
                        value: dataGroup.id,
                        label: dataGroup.group_id
                    }))
                    this.setState({
                        dataGroup: {
                            ...this.state.dataGroup,
                            data: dataGroup
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getDetailUser = () => {
        API_MASTER_DATA.getDetailUser(this.props.match.params.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let userCategory = ''
                    if (getContent(res).level === 'cso') {
                        userCategory = {
                            value: 'cso',
                            label: 'Nexsoft'
                        }
                        this.setState({ isCustomerService: true })
                    }
                    if (getContent(res).level === 'super_admin') {
                        userCategory = {
                            value: 'nexsoft',
                            label: 'Nexsoft'
                        }
                        this.setState({ isCustomerService: true })
                    }
                    if (getContent(res).level === 'nexsoft') {
                        userCategory = {
                            value: 'nexsoft',
                            label: 'Nexsoft'
                        }
                        this.setState({ isCustomerService: true })
                    }
                    if (getContent(res).level === 'distributor') {
                        userCategory = {
                            value: 'distributor',
                            label: 'Distributor'
                        }
                    }
                    if (getContent(res).level === 'principal') {
                        userCategory = {
                            value: 'principal',
                            label: 'Principal'
                        }
                    }
                    this.getListRole(userCategory.value);

                    let csLevel = ''
                    if (getContent(res).cs_level === 'cslv1') {
                        csLevel = {
                            value: 'cslv1',
                            label: 'cslv1'
                        }
                    }
                    if (getContent(res).cs_level === 'cslv2') {
                        csLevel = {
                            value: 'cslv2',
                            label: 'cslv2'
                        }
                    }

                    let complaintData = ''
                    if (getContent(res).specialities !== null) {
                        complaintData = getContent(res).specialities.map(complaint => ({
                            value: complaint.id,
                            label: complaint.complaint
                        }))
                    }

                    let lead = ''
                    if (getContent(res).lead_id !== 0 && getContent(res).leader_name !== '') {
                        lead = {
                            value: getContent(res).lead_id,
                            label: getContent(res).leader_name
                        }
                    }

                    let distributor = ''
                    if (getContent(res).list_distributor !== null) {
                        distributor = getContent(res).list_distributor.map(distributor => ({
                            value: distributor.id,
                            label: distributor.name
                        }))
                    }

                    let title = ''
                    if (getContent(res).title !== '') {
                        title = {
                            value: getContent(res).title,
                            label: getContent(res).title
                        }
                    }

                    let gender = ''
                    if (getContent(res).gender === 'L') {
                        gender = {
                            value: 'L',
                            label: 'Laki-Laki'
                        }
                    }
                    if (getContent(res).gender === 'P') {
                        gender = {
                            value: 'P',
                            label: 'Perempuan'
                        }
                    }
                    if (getContent(res).gender === 'N') {
                        gender = {
                            value: 'N',
                            label: 'Tidak Diketahui'
                        }
                    }

                    let phoneNumber = ''
                    if (getContent(res).phone.includes('-')) {
                        phoneNumber = getContent(res).phone.replaceAll('-', '')
                        if (getContent(res).phone.includes('+62-')) {
                            phoneNumber = getContent(res).phone.replaceAll('+62-', '')
                        }
                        if (phoneNumber[0] === '0') {
                            phoneNumber = phoneNumber.slice(1, phoneNumber.length)
                        }
                    } else if (getContent(res).phone.includes('+62')) {
                        phoneNumber = getContent(res).phone.replaceAll('+62', '')
                    } else if (phoneNumber[0] === '0') {
                        phoneNumber = phoneNumber.slice(1, phoneNumber.length)
                    } else {
                        phoneNumber = getContent(res).phone
                    }

                    this.setState({
                        assignable: getContent(res).assignable,
                        detailUser: getContent(res),
                        id: getContent(res).id,
                        userCategory: {
                            ...this.state.userCategory,
                            value: userCategory
                        },
                        email: getContent(res).email,
                        level: {
                            ...this.state.level,
                            value: csLevel
                        },
                        specialization: {
                            ...this.state.specialization,
                            value: complaintData
                        },
                        lead: {
                            ...this.state.lead,
                            value: lead
                        },
                        isLead: getContent(res).is_lead,
                        distributor: {
                            ...this.state.distributor,
                            value: distributor
                        },
                        idCard: getContent(res).id_card,
                        title: {
                            ...this.state.title,
                            value: title
                        },
                        firstName: getContent(res).first_name,
                        lastName: getContent(res).last_name,
                        gender: {
                            ...this.state.gender,
                            value: gender
                        },
                        phoneNumber: phoneNumber,
                        username: getContent(res).username,
                        password: '',
                        confirmPassword: '',
                        role: {
                            ...this.state.role,
                            value: {
                                value: getContent(res).role_id,
                                label: getContent(res).role_name
                            }
                        },
                        dataGroup: {
                            ...this.state.dataGroup,
                            value: {
                                value: getContent(res).data_group_id,
                                label: getContent(res).data_group_name
                            }
                        },
                        createdAt: moment.utc(getContent(res).created_at).format('DD MMMM YYYY HH:mm'),
                        updatedAt: moment.utc(getContent(res).updated_at).format('DD MMMM YYYY HH:mm'),
                        updatedBy: getContent(res).modified_by,
                        status: getContent(res).status,
                    })
                    this.getDetailUserAuthentication(getContent(res).email, getContent(res).phone);
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getDetailUserAuthentication = (email, phone) => {
        const dataEmail = {
            email: email
        }

        API_AUTHENTICATION.postDetailUser(dataEmail, this.props.token)
            .then(res => {
                if (getContent(res).email !== '') {
                    this.setState({ emailVerified: true })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })

        const dataPhone = {
            phone: this.state.countryCode + "-" + phone
        }

        API_AUTHENTICATION.postDetailUser(dataPhone, this.props.token)
            .then(res => {
                if (getContent(res).phone !== '') {
                    this.setState({ phoneVerified: true })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeUserCategory = data => {
        if (data.value === 'nexsoft') {
            this.setState({
                isCustomerService: true
            })
        }
        this.setState({
            userCategory: {
                ...this.state.userCategory,
                value: data
            }
        })
    }

    handleCheckAssignable = () => {
        if (this.state.detailUser.assignable && !this.state.assignable) {
            return this.setState({ showWarningAlert: true })
        }
        this.handleSubmit();
    }

    handleChangeAssignable = async () => {
        await this.setState({
            assignable: !this.state.assignable,
            showWarningAlert: false
        })
        this.setState({
            userCategory: {
                ...this.state.userCategory,
                value: {
                    value: this.state.assignable ? 'cso' : 'nexsoft',
                    label: 'Nexsoft'
                }
            },
            role: {
                ...this.state.role,
                value: ''
            }
        })
        this.getListRole(this.state.userCategory.value.value)
    }

    handleChangeIsLead = () => {
        this.setState({
            isLead: !this.state.isLead
        })
    }

    handleChangeStatus = () => {
        this.setState({
            status: !this.state.status
        })
    }

    handleChangeLanguage = data => {
        this.setState({
            language: {
                ...this.state.language,
                value: data
            }
        })
    }

    handleChangeGender = data => {
        this.setState({
            gender: {
                ...this.state.gender,
                value: data
            }
        })
    }

    handleChangeLevel = data => {
        if (data === null) {
            data = ''
        }
        this.setState({
            level: {
                ...this.state.level,
                value: data
            }
        })
    }

    handleChangeSpecialization = data => {
        this.setState({
            specialization: {
                ...this.state.specialization,
                value: data
            }
        })
    }

    handleChangeLead = data => {
        if (data === null) {
            data = ''
        }
        this.setState({
            lead: {
                ...this.state.lead,
                value: data
            }
        })
    }

    handleChangeDistributor = data => {
        this.setState({
            distributor: {
                ...this.state.distributor,
                value: data
            }
        })
    }

    handleSearchDistributor = keyword => {
        if (keyword !== '') {
            return this.getSearchDistributor(keyword);
        }
        return this.getListDistributor();
    }

    handleChangeTitle = data => {
        this.setState({
            title: {
                ...this.state.title,
                value: data
            }
        })
    }

    handleChangeRole = data => {
        this.setState({
            role: {
                ...this.state.role,
                value: data
            }
        })
    }

    handleSearchRole = keyword => {
        if (keyword !== '') {
            return this.getSearchRole(keyword);
        }
        return this.getListRole(this.state.userCategory.value.value);
    }

    handleChangeDataGroup = data => {
        this.setState({
            dataGroup: {
                ...this.state.dataGroup,
                value: data
            }
        })
    }

    handleSearchDataGroup = keyword => {
        if (keyword !== '') {
            return this.getSearchDataGroup(keyword);
        }
        return this.getListDataGroup();
    }

    handleChangePage = page => {
        this.setState({ page })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit = () => {
        let data

        let specialities
        if (!this.state.specialization.value) {
            specialities = []
        } else {
            specialities = this.state.specialization.value.map(item => item.value)
        }

        if (this.state.userCategory.value.value === 'cso') {
            data = {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                gender: this.state.gender.value.value,
                list_complaint_id: specialities,
                cs_lead_id: this.state.lead.value.value,
                cs_level: this.state.level.value.value,
                is_cs: this.state.isCustomerService,
                assignable: this.state.assignable,
                is_lead: this.state.isLead,
                id_card: this.state.idCard,
                title: this.state.title.value.value,
                role_id: this.state.role.value.value,
                data_group_id: this.state.dataGroup.value.value,
                updated_at: this.state.detailUser.updated_at,
                status: this.state.status
            }
        }

        if (this.state.userCategory.value.value === 'nexsoft') {
            data = {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                gender: this.state.gender.value.value,
                list_complaint_id: specialities,
                cs_lead_id: this.state.lead.value.value,
                cs_level: this.state.level.value.value,
                is_cs: this.state.isCustomerService,
                assignable: this.state.assignable,
                is_lead: this.state.isLead,
                id_card: this.state.idCard,
                title: this.state.title.value.value,
                role_id: this.state.role.value.value,
                data_group_id: this.state.dataGroup.value.value,
                updated_at: this.state.detailUser.updated_at,
                status: this.state.status
            }
        }

        if (this.state.userCategory.value.value === 'distributor') {
            data = {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                gender: this.state.gender.value.value,
                list_distributor_id: this.state.distributor.value.map(sps => sps.value),
                id_card: this.state.idCard,
                title: this.state.title.value.value,
                role_id: this.state.role.value.value,
                data_group_id: this.state.dataGroup.value.value,
                updated_at: this.state.detailUser.updated_at,
                status: this.state.status
            }
        }

        if (this.state.userCategory.value.value === 'principal') {
            data = {
                first_name: this.state.firstName,
                last_name: this.state.lastName,
                gender: this.state.gender.value.value,
                id_card: this.state.idCard,
                title: this.state.title.value.value,
                role_id: this.state.role.value.value,
                data_group_id: this.state.dataGroup.value.value,
                updated_at: this.state.detailUser.updated_at,
                status: this.state.status
            }
        }

        API_MASTER_DATA.putDataEditUser(data, this.state.detailUser.id, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlert: true,
                    showWarningAlert: false
                })
                setTimeout(() => {
                    this.setState({ showSuccessAlert: false })
                    this.props.history.push(ROUTER_CONSTANT.MASTER_DATA_USER)
                }, 1500);
            }).catch(err => {
                this.setState({ errorMessage: getErrorMessage(err) })
                this.setState({ showErrorAlertResponse: true })
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getDetailUser();
        this.getListCustomerService();
        this.getListSpecialization();
        this.getListDataGroup();
        this.getListDistributor();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_UPDATE]} userPermission={this.props.userDetail.permissions}>
                <div className="user user-edit">
                    <MasterDataUserMenu
                        page={this.state.page}
                        handleChangePage={this.handleChangePage}
                    />

                    <div className={this.state.page === 1 ? "block" : "hidden"}>
                        <MasterDataUserFirstPage
                            page={this.state.page}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            detailUser={this.state.detailUser}
                            id={this.state.id}
                            userCategory={this.state.userCategory}
                            isCustomerService={this.state.isCustomerService}
                            assignable={this.state.assignable}
                            email={this.state.email}
                            language={this.state.language}
                            lead={this.state.lead}
                            isLead={this.state.isLead}
                            level={this.state.level}
                            specialization={this.state.specialization}
                            distributor={this.state.distributor}
                            idCard={this.state.idCard}
                            title={this.state.title}
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            gender={this.state.gender}
                            countryCode={this.state.countryCode}
                            phoneNumber={this.state.phoneNumber}
                            createdAt={this.state.createdAt}
                            updatedAt={this.state.updatedAt}
                            updatedBy={this.state.updatedBy}
                            status={this.state.status}
                            emailVerified={this.state.emailVerified}
                            phoneVerified={this.state.phoneVerified}
                            handleChangeUserCategory={this.handleChangeUserCategory}
                            handleChangeTitle={this.handleChangeTitle}
                            handleChangeAssignable={this.handleChangeAssignable}
                            handleChangeLanguage={this.handleChangeLanguage}
                            handleChangeGender={this.handleChangeGender}
                            handleChangeStatus={this.handleChangeStatus}
                            handleChangeLead={this.handleChangeLead}
                            handleChangeIsLead={this.handleChangeIsLead}
                            handleChangeLevel={this.handleChangeLevel}
                            handleChangeSpecialization={this.handleChangeSpecialization}
                            handleChangeDistributor={this.handleChangeDistributor}
                            handleSearchDistributor={this.handleSearchDistributor}
                            action="edit"
                        />
                    </div>
                    <div className={this.state.page === 2 ? "block" : "hidden"}>
                        <MasterDataUserSecondPage
                            page={this.state.page}
                            username={this.state.username}
                            password={this.state.password}
                            confirmPassword={this.state.confirmPassword}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            action="edit"
                        />
                    </div>
                    <div className={this.state.page === 3 ? "block" : "hidden"}>
                        <MasterDataUserThirdPage
                            page={this.state.page}
                            role={this.state.role}
                            dataGroup={this.state.dataGroup}
                            handleChangeRole={this.handleChangeRole}
                            handleSearchRole={this.handleSearchRole}
                            handleChangeDataGroup={this.handleChangeDataGroup}
                            handleSearchDataGroup={this.handleSearchDataGroup}
                            handleChange={this.handleChange}
                            handleChangePage={this.handleChangePage}
                            handleSubmit={this.handleCheckAssignable}
                            action="edit"
                        />
                    </div>
                    <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil diubah!" />
                    <Alert show={this.state.showWarningAlert} icon="warning" title="User tidak akan dapat membuka tiket dan mengerjakan tiket yang belum dikerjakan. Apakah anda yakin ingin mengubah user tersebut?" button close={() => this.setState({ showWarningAlert: false })} submit={() => this.handleSubmit()} />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserEdit);